import { Stack } from '@mui/material'
import { Header } from '@omnea-app/fe-app-shell/headers/Header'
import { PromotionalBanner } from './PromotionalBanner'
import { SupplierStepsTable } from './SupplierStepsTable/SupplierStepsTable'

export const SupplierDashboard = () => {
  return (
    <>
      <Header showLogo variant="light" />
      <Stack
        height="100%"
        width="100%"
        maxWidth="1200px"
        alignSelf="center"
        padding="40px"
        spacing={10}
        sx={(theme) => ({
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(4),
            gap: theme.spacing(4),
          },
        })}
      >
        <SupplierStepsTable />
      </Stack>
      <PromotionalBanner />
    </>
  )
}
